import { QueryKeyConfig } from './api-helper';

export interface WOReportRequestArgs {
  projectID?: number;
  officeID?: number;
  customerID?: number;
  unitID?: number;
  serviceID?: number;
  inspectorID?: number;
  wOStatusID?: number;
  dateFrom?: string;
  dateTo?: string;
  dateCriteria?: string;
  showAll?: string;
  workorder?: string;
  requestedFromDUX?: boolean;
  // scheduledDateFrom?:string;
  // scheduledDateTo?:string;
}

const getWOReportWithFilters = (filter: WOReportRequestArgs) => {
  const {
    customerID,
    officeID,
    projectID,
    unitID,
    serviceID,
    inspectorID,
    wOStatusID,
    dateFrom,
    dateTo,
    dateCriteria,
    workorder,
    requestedFromDUX,
  } = filter;

  let queryString = '';

  if (customerID) {
    queryString += `${queryString ? '&' : ''}CustomerID=${customerID}`;
  }
  if (officeID) {
    queryString += `${queryString ? '&' : ''}OfficeID=${officeID}`;
  }
  if (projectID) {
    queryString += `${queryString ? '&' : ''}ProjectID=${projectID}`;
  }
  if (unitID) {
    queryString += `${queryString ? '&' : ''}UnitID=${unitID}`;
  }
  if (serviceID) {
    queryString += `${queryString ? '&' : ''}ServiceID=${serviceID}`;
  }
  //   if (inspectorID) {
  //     queryString += `${queryString ? '&' : ''}InspectorID=${inspectorID}`;
  //   }
  if (workorder) {
    queryString += `${queryString ? '&' : ''}WONumber=${workorder}`;
  }
  if (dateFrom) {
    queryString += `${queryString ? '&' : ''}DateFrom=${dateFrom}`;
  }
  if (dateTo) {
    queryString += `${queryString ? '&' : ''}DateTo=${dateTo}`;
  }
  queryString += `${queryString ? '&' : ''}RequestedFromDUX=${!requestedFromDUX ? false : true}`;
  //   if (dateCriteria) {
  //     queryString += `${queryString ? '&' : ''}DateCriteria=${dateCriteria}`;
  //   }
  // if (scheduledDateFrom) {
  //   queryString += `${queryString ? '&' : ''}ScheduledDateFrom=${scheduledDateFrom}`;
  // }
  // if (scheduledDateTo) {
  //   queryString += `${queryString ? '&' : ''}ScheduledDateTo=${scheduledDateTo}`;
  // }
  return queryString;
};
export const billingReportApiKeyStore = {
  getBillingReports: (args: WOReportRequestArgs): QueryKeyConfig => ({
    queryKey: [
      `GET_BILLING_REPORTS`,
      [
        args.customerID,
        args.officeID,
        args.projectID,
        args.unitID,
        args.serviceID,
        args.inspectorID,
        args.wOStatusID,
        args.dateFrom,
        args.dateTo,
        args.dateCriteria,
        args.showAll,
        args.workorder,
        args.requestedFromDUX,
        // args.scheduledDateTo,
      ].filter((a) => a),
    ],
    route: `/WorkOrder/DuxInspectionBillingReport?${getWOReportWithFilters(args)}`,
  }),
};
